import classNames from 'classnames';
import { useFormikContext } from 'formik';
import React from 'react';

import { ReactComponent as SpinnerIcon } from '../../assets/spinner.svg';
import {
	busyButton as busyButtonStyle,
	button as buttonStyle,
	error as errorStyle,
	spinner as spinnerStyle,
} from './style.module.css';

const isDisabled = (disabled: boolean) => {
	const { isValid, dirty } = useFormikContext();
	return !isValid || !dirty || disabled;
};

const isBusy = (submitError?: boolean) => {
	const { isSubmitting } = useFormikContext();
	return isSubmitting && !submitError;
};

interface SubmitProps {
	submitError?: boolean;
	disabled?: boolean;
	prompt?: string;
	errorPrompt?: string;
	errorMessage?: string;
	supportEmail?: string;
}

export const Submit = ({
	submitError,
	disabled,
	prompt = 'Submit',
	errorPrompt = 'Retry',
	errorMessage,
	supportEmail,
}: SubmitProps): JSX.Element => {
	return (
		<>
			<button
				type="submit"
				className={classNames(buttonStyle, isBusy(submitError) && busyButtonStyle)}
				disabled={isDisabled(disabled ?? false)}
			>
				{isBusy(submitError) ? (
					<SpinnerIcon className={spinnerStyle} />
				) : submitError ? (
					errorPrompt
				) : (
					prompt
				)}
			</button>
			{!isDisabled(disabled ?? false) && submitError && !!errorMessage && !!supportEmail && (
				<span className={classNames(errorStyle)}>
					{errorMessage} <a href={`"mailto:${supportEmail}"`}>{supportEmail}</a>
				</span>
			)}
		</>
	);
};
